import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Button,
  Flex,
  Input,
  Select,
  DatePicker,
  Form,
  Modal,
  Tag,
  Spin,
  Space,
  Divider,
  Typography,
  message,
  Checkbox,
} from "antd";
import { useWatch } from "antd/es/form/Form";
import dayjs from "dayjs";
import moment from "moment";
import {
  meetingRoomApis,
  roomBookingApi,
  staticApis,
  clientsApi,
  inviteesApi,
} from "../../api";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import SlotBookingPopup from "./SlotBookingPopup";
import ClockTimePicker from "./ClockTimePicker";
import { WeeklyCalendar } from "./WeeklyCalendar";
import {
  setSelectedMeetingRoom,
  setSelectedCity,
} from "../../reducer/meetingSlice";
import { employeeId, GetRole, userNameEmpId } from "../../userRole";
import {
  _dayOfWeek,
  _daysOfWeek,
  MAX_BOOKING_ADVANCE_DAYS,
  ADMIN_MAX_BOOKING_ADVANCE_DAYS,
  MAX_DAILY_BOOKING_HOURS,
  MAX_EXCEPTION_DAILY_BOOKING_HOURS,
  MONTHLY_EXCEPTION_LIMIT,
} from "../../utils/Constants";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  LinkOutlined,
  TeamOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import encode from "jwt-encode";
import { current } from "@reduxjs/toolkit";
import "./styles.css";
const { Text, Paragraph } = Typography;
//import './Rb.css';

const { RangePicker } = DatePicker;
const JWT_SECRET = process.env.REACT_APP_JWT_SECRET; // Your secret key
const APP_ID = process.env.REACT_APP_APP_ID; // Your app ID
const Domain = process.env.REACT_APP_DOMAIN;

const Rb = () => {
  const role = GetRole();
  const isAdmin = role === "admin";
  const [concurrenceOptions, setConcurrenceOptions] = useState([]);
  const [meetingRooms, setMeetingRooms] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateChanged, setDateChanged] = useState(null);
  const [selectedMeetingRoom, setSelectedMeetingRoom] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [concurrenceType, setConcurrenceType] = useState(1);
  const [form] = Form.useForm();
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const { TimePicker } = DatePicker;
  const [roomEvents, setRoomEvents] = useState([]);
  const [agenda, setAgenda] = useState("");
  const [cityList, setCityList] = useState([]);
  const dispatch = useDispatch();

  const [myEvents, setEvents] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: moment().startOf("week").toDate(),
    end: moment().endOf("week").toDate(),
  });
  const [selectedSlot, setSelectedSlot] = useState(null);
  const selectedDate = state?.selectedDate;
  const [startDate, setStartDate] = useState(
    selectedDate ? dayjs(selectedDate) : dayjs()
  );

  //const [startDate, setStartDate] = useState(selectedDate || dayjs());

  const [endDate, setEndDate] = useState(dayjs());
  const [startTime, setStartTime] = useState(dayjs().add(0, "minute"));
  const [endTime, setEndTime] = useState(dayjs().add(30, "minute"));

  const [checkSlot, setCheckSlot] = useState([]);
  const [selectedInvitees, setSelectedInvitees] = useState([]);
  const [loadingInvitees, setLoadingInvitees] = useState([]);

  const [meetingType, setMeetingType] = useState("onsite");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [exceptionQuota, setExceptionQuota] = useState({
    used: 0,
    reserved: 0,
    limit: MONTHLY_EXCEPTION_LIMIT,
    remaining: MONTHLY_EXCEPTION_LIMIT,
  });
  const [dailyUsedMinutes, setDailyUsedMinutes] = useState(0);

  const maxAdvanceDays = isAdmin
    ? ADMIN_MAX_BOOKING_ADVANCE_DAYS
    : MAX_BOOKING_ADVANCE_DAYS;
  const maxBookableDate = dayjs().add(maxAdvanceDays, "day").endOf("day");

  const formatDurationLabel = (minutes) => {
    const total = Math.max(0, Math.floor(Number(minutes) || 0));
    const h = Math.floor(total / 60);
    const m = total % 60;
    if (h > 0 && m > 0) return `${h}h ${m}m`;
    if (h > 0) return `${h}h`;
    return `${m}m`;
  };

  const getBookingErrorMessage = (error) => {
    const apiMessage = error?.response?.data?.message;
    if (typeof apiMessage === "string" && apiMessage.trim()) {
      return apiMessage;
    }
    if (apiMessage && typeof apiMessage === "object") {
      const first = Object.values(apiMessage).find(Boolean);
      if (first) return String(first);
    }
    return null;
  };

  const validateBookingDateWithinWindow = (_, value) => {
    if (!value) return Promise.resolve();
    const today = dayjs().startOf("day");
    const selected = dayjs(value).startOf("day");
    if (selected.isBefore(today, "day")) {
      return Promise.reject(
        new Error("Bookings cannot be made for past dates. Please select today or a future date.")
      );
    }
    if (selected.isAfter(maxBookableDate, "day")) {
      return Promise.reject(
        new Error(
          `Bookings can only be made up to ${maxAdvanceDays} days in advance. Please select a date on or before ${maxBookableDate.format(
            "DD-MM-YYYY"
          )}.`
        )
      );
    }
    return Promise.resolve();
  };

  const validateEndTimeWithinDailyLimit = ({ getFieldValue }) => ({
    validator(_, value) {
      const startTimeValue = getFieldValue("startTime");
      const useException = Boolean(getFieldValue("isException"));
      if (!value || !startTimeValue) {
        return Promise.resolve();
      }
      if (!value.isAfter(startTimeValue)) {
        return Promise.reject(
          new Error("End time must be after start time. Please choose a valid time range.")
        );
      }
      const durationMinutes = value.diff(startTimeValue, "minute");
      const limitMinutes = useException
        ? MAX_EXCEPTION_DAILY_BOOKING_HOURS * 60
        : MAX_DAILY_BOOKING_HOURS * 60;

      if (useException && exceptionQuota.remaining < 1) {
        return Promise.reject(
          new Error(
            `You have used all ${MONTHLY_EXCEPTION_LIMIT} exceptions for this month. Uncheck the exception option and keep within ${MAX_DAILY_BOOKING_HOURS} hours/day.`
          )
        );
      }

      const remaining = Math.max(0, limitMinutes - dailyUsedMinutes);

      if (remaining < 15) {
        return Promise.reject(
          new Error(
            `No booking time left today under the ${
              useException
                ? MAX_EXCEPTION_DAILY_BOOKING_HOURS
                : MAX_DAILY_BOOKING_HOURS
            }-hour limit (${formatDurationLabel(dailyUsedMinutes)} already used).`
          )
        );
      }

      if (durationMinutes > remaining) {
        return Promise.reject(
          new Error(
            `Only ${formatDurationLabel(remaining)} left today (${formatDurationLabel(
              dailyUsedMinutes
            )} used of ${formatDurationLabel(limitMinutes)}). Shorten the end time${
              !useException
                ? `, or enable “Use monthly exception” for up to ${MAX_EXCEPTION_DAILY_BOOKING_HOURS} hours`
                : ""
            }.`
          )
        );
      }
      return Promise.resolve();
    },
  });

  const [isBooking, setIsBooking] = useState(false);
  const [isScheduleMeeting, setScheduleMeeting] = useState(false);
  const [meetingLink, setMeetingLink] = useState("");
  const [moderatorLink, setModeratorLink] = useState("");

  const concurrencyType = useWatch("concurrenceTypeId", form);
  const isExceptionSelected = useWatch("isException", form);
  const watchedStartDate = useWatch("concurrencyStartDate", form);
  const watchedStartTime = useWatch("startTime", form);
  const isWeekdayRecurrence = isAdmin && Number(concurrencyType) === 5;
  // Every Weekday layout: Booking type | Start Time, End Time | Usage, Start Date | End Date
  const weekdayRowStyle = isWeekdayRecurrence ? { display: "contents" } : undefined;
  const weekdayOrder = (order) =>
    isWeekdayRecurrence ? { order } : undefined;
  const bookingDateValue =
    isWeekdayRecurrence && watchedStartDate ? dayjs(watchedStartDate) : dayjs();
  const bookingDateKey = bookingDateValue.format("YYYY-MM-DD");
  const isBookingToday = bookingDateValue.isSame(dayjs(), "day");

  const dailyLimitMinutes = isExceptionSelected
    ? MAX_EXCEPTION_DAILY_BOOKING_HOURS * 60
    : MAX_DAILY_BOOKING_HOURS * 60;
  const remainingDailyMinutes = Math.max(
    0,
    dailyLimitMinutes - dailyUsedMinutes
  );
  const exceptionsExhausted = exceptionQuota.remaining < 1;

  const getUsageBadgeColors = (usedMinutes, useExceptionTheme) => {
    const normalLimit = MAX_DAILY_BOOKING_HOURS * 60;
    const exceptionLimit = MAX_EXCEPTION_DAILY_BOOKING_HOURS * 60;
    if (useExceptionTheme) {
      // Exception (4h): <=2h green, 2h–3h yellow, 3h–3h30m dark orange, >=3h30m red
      if (usedMinutes >= exceptionLimit - 30) {
        return { background: "#fff2f0", border: "#ffccc7" };
      }
      if (usedMinutes > exceptionLimit - 60) {
        return { background: "#fff7e6", border: "#ff9c6e" };
      }
      if (usedMinutes > normalLimit) {
        return { background: "#fffbe6", border: "#ffe58f" };
      }
      return { background: "#f6ffed", border: "#b7eb8f" };
    }
    // Normal (2h): <=1h green, 1h–1h30m yellow, 1h30m–2h dark orange, >=2h red
    if (usedMinutes >= normalLimit) {
      return { background: "#fff2f0", border: "#ffccc7" };
    }
    if (usedMinutes > normalLimit * 0.75) {
      return { background: "#fff7e6", border: "#ff9c6e" };
    }
    if (usedMinutes > normalLimit * 0.5) {
      return { background: "#fffbe6", border: "#ffe58f" };
    }
    return { background: "#f6ffed", border: "#b7eb8f" };
  };
  const usageBadgeColors = getUsageBadgeColors(
    dailyUsedMinutes,
    Boolean(isExceptionSelected)
  );

  const handleMeetingRoomChange = (value) => {
    setSelectedMeetingRoom(value);
  };

  const calculateWeekdays = (startDate, endDate) => {
    let count = 0;
    let currentDate = dayjs(startDate);

    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, "day")
    ) {
      const dayOfWeek = currentDate.day(); // 0 for Sunday, 6 for Saturday
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        count++;
      }
      currentDate = currentDate.add(1, "day"); // Move to the next day
    }

    return count;
  };

  const calculateWeekly = (startDate, endDate, selectedWeeks) => {
    let count = 0;
    let currentDate = dayjs(startDate);

    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, "day")
    ) {
      const dayOfWeek = currentDate.day(); // 0 for Sunday, 6 for Saturday
      if (selectedWeeks.includes(dayOfWeek)) {
        count++;
      }
      currentDate = currentDate.add(1, "day"); // Move to the next day
    }

    return count;
  };

  const handleCityChange = (value) => {
    setSelectedCity(value);
  };

  const handleSelectSlot = (slotInfo) => {
    const start = dayjs(slotInfo.start);
    const end = dayjs(slotInfo.end);
    const today = dayjs().startOf("day");

    if (!start.isValid() || !end.isValid() || start < dayjs()) {
      console.error("Invalid start or end date");
      return;
    }

    if (!isWeekdayRecurrence && !start.isSame(today, "day")) {
      toast.error("Rooms can only be booked for today.");
      return;
    }

    if (isWeekdayRecurrence && start.isAfter(maxBookableDate, "day")) {
      toast.error(
        `Bookings can only be made up to ${maxAdvanceDays} days in advance.`
      );
      return;
    }

    setStartDate(start);
    // setEndDate(end);
    setStartTime(start);
    setEndTime(end);
    setSelectedSlot(slotInfo);

    const currentEndDate = form.getFieldValue("concurrencyEndDate");
    form.setFieldsValue({
      concurrencyStartDate: start,
      concurrencyEndDate:
        isWeekdayRecurrence &&
        currentEndDate &&
        !dayjs(currentEndDate).isBefore(start, "day")
          ? currentEndDate
          : start,
      startTime: start,
      endTime: end,
    });
    form.validateFields([
      "concurrencyStartDate",
      "startTime",
      "endTime",
    ]);
  };

  const handleInputChange = (field, value) => {
    if (field === "startDate") {
      const dateValue = dayjs(value);
      setStartDate(dateValue);
      // Explicitly validate the field after setting the value
      form.validateFields(["concurrencyStartDate"]);
    }
    switch (field) {
      case "endDate":
        setEndDate(value);
        form.setFieldsValue({ concurrencyEndDate: value });

        if (startDate && dayjs(startDate).isAfter(value)) {
          form.setFields([
            {
              name: "concurrencyStartDate",
              errors: ["Start date must be less than end date"],
            },
          ]);
        } else {
          form.setFields([{ name: "concurrencyStartDate", errors: [] }]);
        }
        break;

      case "startTime":
        if (value) {
          setStartTime(value);
          form.setFieldsValue({ startTime: value });
        } else {
          // Handle null value when clearing
          setStartTime(null);
          form.setFieldsValue({ startTime: null });
        }
        break;
      case "endTime":
        if (value) {
          setEndTime(value);
          form.setFieldsValue({ endTime: value });
        } else {
          // Handle null value when clearing
          setEndTime(null);
          form.setFieldsValue({ endTime: null });
        }
        setDateChanged(
          dayjs(value).startOf("day").isSame(dayjs().startOf("day"))
        );
        form.validateFields(["startTime"]);
        break;
      default:
        break;
    }
    form.validateFields([field]);
  };

  const filteredMeetingRooms = selectedCity
    ? meetingRooms.filter((room) =>
        cityList.some((city) => {
          return city.label === room.place;
        })
      )
    : [];

  useEffect(() => {
    const fetchAvailableRoomData = async () => {
      try {
        const formattedStartDate = dayjs(dateRange.start).format("YYYY-MM-DD");
        const formattedEndDate = dayjs(dateRange.end).format("YYYY-MM-DD");
        let payload = {};
        if (meetingType === "virtual") {
          payload = {
            meetingRoomId: null,
            startDate: formattedStartDate,
            meetingType: meetingType,
            createdBy: employeeId,
          };
          setSelectedMeetingRoom(null);
        } else {
          payload = {
            meetingRoomId: selectedMeetingRoom,
            startDate: formattedStartDate,
            meetingType: meetingType,
            createdBy: null,
          };
        }
        payload.endDate = formattedEndDate;
        const response = await meetingRoomApis.getMeetingsOfMeetingRoom(
          payload
        );

        const meetingsData = response?.data?.map((meeting) => {
          const meetingData = {
            start: moment(meeting.date + "T" + meeting.startTime).toDate(),
            end: moment(meeting.date + "T" + meeting.endTime).toDate(),
            bookedBy: meeting.name,
          };
          if (role === "admin") meetingData.title = meeting.name;
          return meetingData;
        });

        setRoomEvents(meetingsData);
      } catch (err) {
        setRoomEvents([]);
        console.error("Error fetching availability data:", err);
      }
    };

    fetchAvailableRoomData();
  }, [dateRange.start, dateRange.end, selectedMeetingRoom, meetingType]);

  // useEffect(() => {
  //   const fetchMeetingData = async () => {
  //     try {
  //       const response = await roomBookingApi.getMeetingListData({
  //         empCode: employeeId,
  //         startDate: dateRange.start,
  //         endDate: dateRange.end,
  //       });

  //       const meetingsData = response.data.map((meeting) => ({
  //         id: meeting.id,
  //         start: moment(meeting.date + "T" + meeting.startTime).toDate(),
  //         end: moment(meeting.date + "T" + meeting.endTime).toDate(),
  //         title: meeting.subject,
  //         rtId: meeting.rtId,
  //         createdBy: meeting.createdBy,
  //         empCode: meeting.empCode,
  //         date: meeting.date,
  //         mrId: meeting.mrId,
  //         agenda: meeting.agenda,
  //         meetingRoomName: meeting.name,
  //         rbId: meeting.rbId,
  //         meetingRoomLink: meeting.meetingRoomLink,
  //       }));

  //       setEvents(meetingsData);
  //     } catch (error) {
  //       console.error("Error fetching meeting data:", error);
  //       setEvents([]);
  //     }
  //   };

  //   fetchMeetingData();
  // }, [dateRange.start && dateRange.end]);

  useEffect(() => {
    staticApis.getConcurrencyTypes().then((res) => {
      const optionsData = res.data
        .filter((data) => data.id === 1 || data.id === 5)
        .map((concurrency) => {
          const fullLabel = concurrency.name;
          // Selected value: "Every Weekday" without bracket text; dropdown keeps full label
          const label =
            concurrency.id === 5
              ? fullLabel.replace(/\s*\([^)]*\)\s*/g, "").trim()
              : fullLabel;
          return {
            value: concurrency.id,
            label,
            fullLabel,
          };
        });
      setConcurrenceOptions([...optionsData]);
      form.setFieldValue("concurrenceTypeId", optionsData[0].value);
    });
  }, [meetingType]);

  const refreshBookingQuotas = useCallback(async () => {
    if (!employeeId) return;
    const date = bookingDateKey;
    try {
      const [usageRes, quotaRes] = await Promise.all([
        roomBookingApi.getDailyUsage(employeeId, { date }),
        roomBookingApi.getExceptionQuota(employeeId, { date }),
      ]);
      setDailyUsedMinutes(usageRes?.data?.usedMinutes || 0);
      if (quotaRes?.data) {
        setExceptionQuota(quotaRes.data);
      }
    } catch (err) {
      console.warn("[booking] Failed to refresh usage/exception quotas:", err);
    }
  }, [employeeId, bookingDateKey]);

  useEffect(() => {
    refreshBookingQuotas();
  }, [refreshBookingQuotas, location.key]);

  useEffect(() => {
    const onBookingChanged = () => {
      refreshBookingQuotas();
    };
    window.addEventListener("meeting-booking-changed", onBookingChanged);
    return () =>
      window.removeEventListener("meeting-booking-changed", onBookingChanged);
  }, [refreshBookingQuotas]);

  useEffect(() => {
    if (exceptionQuota.remaining < 1 && form.getFieldValue("isException")) {
      form.setFieldValue("isException", false);
    }
  }, [exceptionQuota.remaining, form]);

  useEffect(() => {
    if (isWeekdayRecurrence && form.getFieldValue("isException")) {
      form.setFieldValue("isException", false);
    }
  }, [isWeekdayRecurrence, form]);

  // useEffect(() => {
  //   clientsApi.getCityList().then((res) => {
  //     const cityList = res?.data?.map((mCity) => {
  //       return {
  //         value: mCity.id,
  //         label: mCity.name,
  //       };
  //     });
  //     setCityList([...cityList]);
  //   });
  // }, []);

  useEffect(() => {
    meetingRoomApis.meetingRoomAllData().then((res) => {
      const meetingRooms = res?.data?.map((mRoom) => {
        return {
          value: mRoom.mrId,
          label: `${mRoom.name} ${
            mRoom.isUnderMaintenance ? "is under maintenance" : ""
          }`,
          place: mRoom.place,
          disabled: mRoom.isUnderMaintenance,
        };
      });
      setMeetingRooms([...meetingRooms]);
    });
  }, []);

  useEffect(() => {
    const getEmployees = async () => {
      setLoading(true);
      try {
        const resp = await staticApis.getEmployeesData(employeeId);
        const currentLocation = resp?.data?.employeeLocation;
        const employeesData = resp?.data?.employeesData.map((employee) => {
          return {
            label: employee.name + " ( " + employee.employeeNo + " ) ",
            value: employee.employeeNo,
          };
        });
        setEmployees([...employeesData]);
        setCityList([
          {
            value: currentLocation.placeId,
            label: currentLocation.location,
          },
        ]);
        setSelectedCity(currentLocation.location);
        form.setFieldValue("placeId", currentLocation.placeId);
      } catch (err) {
        console.log("ERROR IN GET EMPLOYEES DATA API ", err);
      }
      setLoading(false);
    };
    getEmployees();
  }, []);

  const fetchAvailability = async (invitees) => {
    setLoadingInvitees(invitees); // Set loading for selected invitees
    try {
      const resp = await inviteesApi.checkSlotAvailability({
        empCodes: invitees,
        date: dayjs(startDate).startOf("day").format("YYYY-MM-DD"),
        startTime: dayjs(startTime).startOf("minute").format("HH:mm"),
        endTime: dayjs(endTime).startOf("minute").format("HH:mm"),
      });
      setCheckSlot(resp.data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingInvitees([]);
    }
  };

  useEffect(() => {
    if (selectedInvitees.length > 0) {
      fetchAvailability(selectedInvitees);
    }
  }, [selectedInvitees, startDate, startTime, endTime]);

  const handleInviteesChange = (values) => {
    setSelectedInvitees(values);
  };

  const getAvailability = (empCode) => {
    if (!checkSlot || !Array.isArray(checkSlot)) return null;
    const availabilityInfo = checkSlot.find((slot) => slot.empCode === empCode);
    return availabilityInfo ? availabilityInfo.availability : null;
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const isLoading = loadingInvitees.includes(value); // Check if the invitee is loading
    const availability = checkSlot.find(
      (slot) => slot.empCode === value
    )?.availability;
    const color = availability ? "green" : "red";

    return (
      <Tag
        color={isLoading ? "blue" : color}
        closable={closable}
        onClose={onClose}
        style={{ display: "flex", alignItems: "center" }}
      >
        {label}
        {isLoading && <Spin size="small" style={{ marginLeft: 8 }} />}
      </Tag>
    );
  };

  useEffect(() => {
    form.resetFields(["mrId"]);
  }, [selectedCity]);

  const validateStartDate = (_, value) => {
    const formattedValue = value.format("DD-MM-YYYY");
    if (concurrenceType === 1) {
      return Promise.resolve();
    }
    const endingDate = endDate.format("DD-MM-YYYY");
    if (value && endingDate && endingDate <= formattedValue) {
      return Promise.reject("Start must be less than end date");
    }
    return Promise.resolve();
  };

  const validateStartTime = (_, value) => {
    const endTime = form.getFieldValue("endTime").format("HH:mm");
    const formattedValue = value.format("HH:mm");

    if (formattedValue >= endTime) {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  const validateEndTime = (_, value) => {
    const startTime = form.getFieldValue("startTime").format("HH:mm");
    const formattedValue = value.format("HH:mm");

    if (formattedValue <= startTime) {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    const subject = `Meeting-${randomNum}`;

    const moderatorToken = generateModeratorToken();
    if (!moderatorToken) {
      toast.error("Failed to generate moderator token");
      return;
    }

    const formattedSubject = subject.toLowerCase().replace(/\s+/g, "-");
    const meetingRoomLink = `https://${Domain}/${formattedSubject}`;
    const moderatorRoomLink = `${meetingRoomLink}?jwt=${moderatorToken}`;

    setMeetingLink(meetingRoomLink);
    setModeratorLink(moderatorRoomLink);
  }, [isModalOpen]);

  const createInstantMeeting = async (isStartNow = false) => {
  
       setIsBooking(true);
    const agenda = '';

    const now = dayjs();
    const startTime = now.format("HH:mm");
    const endTime = now.add(30, "minute").format("HH:mm");

    const concurrenceTypeId = 1; // or use a fixed ID you need

    const virtualMeetingData = {
      meetingType: "virtual",
      concurrenceTypeId,
      concurrence: [now.day()],
      concurrencyStartDate: now.format("YYYY-MM-DD"),
      concurrencyEndDate: now.format("YYYY-MM-DD"),
      startTime,
      endTime,
      roomInvitees: [employeeId],
      otherInvitees: [],
      subject : 'Instant meeting',
      agenda,
      meetingRoomLink:meetingLink,
      moderatorRoomLink:moderatorLink,
      createdBy: employeeId,
    };


    try {
      const response = await roomBookingApi.bookRoom(virtualMeetingData);
      setIsModalOpen(false); // Show modal with links
      setIsBooking(false);
      if (response.status === "success") {
        toast.success("Instant meeting saved successfully");

        
        if (isStartNow){
        // This navigates the current tab
          window.location.href = moderatorLink;

           
        }else{
           navigate("/");
        }
      
      }
    } catch (error) {
      console.error("Error saving instant meeting:", error);
      toast.error("Failed to save instant meeting");
    }
  };

  const generateModeratorToken = (userData) => {
    try {
      const payload = {
        context: {
          user: {
            name: userNameEmpId.name, // Get name from userNameEmpId
            email: userNameEmpId.email, // Get email from form or user data
          },
        },
        moderator: true,
        aud: APP_ID,
        iss: APP_ID,
        sub: Domain,
        room: "*",
      };

      // Generate token with 24 hours expiry
      const token = encode(payload, JWT_SECRET);
      return token;
    } catch (error) {
      console.error("Error generating moderator token:", error);
      return null;
    }
  };

  const bookRoomAfterCheck = async (values) => {
    setIsBooking(true);
    if (Boolean(values.isException) && exceptionQuota.remaining < 1) {
      toast.error(
        `You have used all ${MONTHLY_EXCEPTION_LIMIT} exceptions for this month. Shorten the booking to within ${MAX_DAILY_BOOKING_HOURS} hours/day, or try again next month.`
      );
      form.setFieldValue("isException", false);
      setIsBooking(false);
      return;
    }
    const roomInviteeslist =
      values.roomInvitees?.length > 0
        ? [employeeId, ...values.roomInvitees] // Add creator ID at the start
        : [employeeId];
    if (meetingType === "virtual") {
      const {
        startTime,
        endTime,
        roomInvitees,
        otherInvitees,
        subject,
        agenda,
      } = values;

      const moderatorToken = generateModeratorToken();

      if (!moderatorToken) {
        toast.error("Failed to generate moderator token");
        return;
      }

      const randomNum = Math.floor(Math.random() * 1000000);

      // Create meeting room link
      const formattedSubject = subject.toLowerCase().replace(/\s+/g, "-");
      const meetingRoomLink = `https://${Domain}/${formattedSubject}-${randomNum}`;

      // Create moderator room link (append -mod to the meeting link)
      const moderatorRoomLink = `${meetingRoomLink}?jwt=${moderatorToken}`;

      let otherInviteesArray = null;
      if (otherInvitees) {
        otherInviteesArray = otherInvitees
          .split(",")
          .map((email) => email.trim())
          .filter((email) => email !== "");
      }

      const bookingDate = dayjs().format("YYYY-MM-DD");

      const virtualMeetingData = {
        meetingType: "virtual",
        concurrenceTypeId: 1,
        concurrence: [dayjs().day()],
        concurrencyStartDate: bookingDate,
        concurrencyEndDate: bookingDate,
        startTime: dayjs(startTime).format("HH:mm"),
        endTime: dayjs(endTime).format("HH:mm"),
        roomInvitees: roomInviteeslist,
        otherInvitees: otherInviteesArray,
        subject,
        agenda,
        meetingRoomLink,
        moderatorRoomLink,
        createdBy: employeeId, // Add createdBy same as onsite
        managerEmpCode: values.managerEmpCode || null,
      };

      try {
        const response = await roomBookingApi.bookRoom(virtualMeetingData);
        if (response.status === "success") {
          toast.success("Virtual meeting booked successfully");
          await refreshBookingQuotas();
          window.dispatchEvent(new Event("meeting-booking-changed"));
          form.resetFields();
          navigate("/");
        }
      } catch (error) {
        console.error("Error booking virtual meeting:", error);
        toast.error(
          getBookingErrorMessage(error) || "Failed to book virtual meeting"
        );
      } finally {
        setIsBooking(false);
      }
    } else {
      const {
        startTime,
        endTime,
        subject,
        agenda,
        mrId,
        placeId,
      } = values;

      const { meetingRoomLink: userEnteredLink } = values;
      const bookingConcurrenceTypeId =
        isAdmin && Number(values.concurrenceTypeId) === 5 ? 5 : 1;
      const bookingDate =
        bookingConcurrenceTypeId === 5 && values.concurrencyStartDate
          ? dayjs(values.concurrencyStartDate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD");
      const bookingEndDate =
        bookingConcurrenceTypeId === 5 && values.concurrencyEndDate
          ? dayjs(values.concurrencyEndDate).format("YYYY-MM-DD")
          : bookingDate;

      const onsiteMeetingData = {
        meetingType: "onsite",
        concurrenceTypeId: bookingConcurrenceTypeId,
        concurrencyStartDate: bookingDate,
        concurrencyEndDate: bookingEndDate,
        startTime: dayjs(startTime).format("HH:mm"),
        endTime: dayjs(endTime).format("HH:mm"),
        roomInvitees: roomInviteeslist,
        subject,
        agenda,
        mrId,
        placeId: Number(placeId), // Ensure placeId is a number
        createdBy: employeeId,
        meetingRoomLink: userEnteredLink,
        moderatorRoomLink: null,
        managerEmpCode: values.managerEmpCode || null,
        isException:
          bookingConcurrenceTypeId === 5 ? false : Boolean(values.isException),
        ...(bookingConcurrenceTypeId === 5
          ? {}
          : { concurrence: [bookingDate] }),
      };

      try {
        const meetingRoomPayload = {
          startTime: dayjs(startTime).format("HH:mm"),
          endTime: dayjs(endTime).format("HH:mm"),
          concurrencyStartDate: bookingDate,
          concurrencyEndDate: bookingEndDate,
          mrId,
          rtId: null,
        };

        const resp = await meetingRoomApis.getAvailabilityOfMeetingRoom(
          meetingRoomPayload
        );

        if (resp?.data?.noOfUnavailableSlots > 0) {
          const clashDates = (resp?.data?.unavailableDates || [])
            .map((d) => dayjs(d).format("DD-MM-YYYY"))
            .join(", ");
          toast.error(
            clashDates
              ? `Meeting room not available on: ${clashDates}. Please choose a different slot.`
              : "Meeting room not available for the selected date and time. Please choose a different slot."
          );
          return;
        }

        const response = await roomBookingApi.bookRoom(onsiteMeetingData);
        if (response.status === "success") {
          toast.success(response.message);
          await refreshBookingQuotas();
          window.dispatchEvent(new Event("meeting-booking-changed"));
          form.resetFields();
          navigate("/");
        } else if (response?.message) {
          toast.error(
            typeof response.message === "string"
              ? response.message
              : "Failed to book onsite meeting"
          );
        }
      } catch (error) {
        console.error("Error booking onsite meeting:", error);
        toast.error(
          getBookingErrorMessage(error) || "Failed to book onsite meeting"
        );
      } finally {
        setIsBooking(false);
      }
    }
  };

  const handleMeetingTypeChange = (type) => {
    setMeetingType(type);
    setScheduleMeeting(false);
    form.resetFields();
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Update just this function to handle all cases
  const disabledTime = (current) => {
    // Get the selected date from the form
    const selectedDate = form.getFieldValue("concurrencyStartDate") || dayjs();

    // If no date is selected or if it's a future date, allow all times
    if (
      !selectedDate ||
      dayjs(selectedDate).format("YYYY-MM-DD") > dayjs().format("YYYY-MM-DD")
    ) {
      return {};
    }

    // Only apply restrictions if the selected date is today
    if (
      dayjs(selectedDate).format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD")
    ) {
      const currentHour = dayjs().hour();
      const currentMinute = dayjs().minute();

      return {
        disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === currentHour) {
            return Array.from({ length: currentMinute }, (_, i) => i);
          }
          return [];
        },
      };
    }

    // For all other cases, allow all times
    return {};
  };

  const getMaxAllowedEndTime = (start) => {
    if (!start) return null;
    return dayjs(start).add(remainingDailyMinutes, "minute");
  };

  const clampEndTimeToRemaining = (start, preferredEnd) => {
    if (!start) return preferredEnd;
    const minEnd = dayjs(start).add(15, "minute");
    const maxEnd = getMaxAllowedEndTime(start);
    if (!maxEnd || remainingDailyMinutes < 15) {
      return minEnd;
    }
    let next = preferredEnd || dayjs(start).add(30, "minute");
    if (next.isBefore(minEnd)) next = minEnd;
    if (next.isAfter(maxEnd)) next = maxEnd;
    return next;
  };

  const disabledEndTime = () => {
    const start = form.getFieldValue("startTime");
    const pastLimits = disabledTime();
    if (!start) return pastLimits;

    const minEnd = dayjs(start).add(15, "minute");
    const maxEnd = getMaxAllowedEndTime(start);
    const rangeStart = minEnd;
    const rangeEnd =
      maxEnd && maxEnd.isAfter(minEnd) ? maxEnd : minEnd;

    const pastDisabledHours = pastLimits.disabledHours
      ? pastLimits.disabledHours()
      : [];

    return {
      disabledHours: () => {
        const disabled = new Set(pastDisabledHours);
        for (let h = 0; h < 24; h += 1) {
          if (h < rangeStart.hour() || h > rangeEnd.hour()) {
            disabled.add(h);
          }
        }
        return Array.from(disabled).sort((a, b) => a - b);
      },
      disabledMinutes: (selectedHour) => {
        const disabled = new Set();
        const pastMinutes =
          pastLimits.disabledMinutes?.(selectedHour) || [];
        pastMinutes.forEach((m) => disabled.add(m));

        for (let m = 0; m < 60; m += 1) {
          const candidate = dayjs(start)
            .hour(selectedHour)
            .minute(m)
            .second(0);
          if (
            candidate.isBefore(rangeStart) ||
            candidate.isAfter(rangeEnd)
          ) {
            disabled.add(m);
          }
        }
        return Array.from(disabled).sort((a, b) => a - b);
      },
    };
  };

  // Function to handle start time change and auto-populate end time
  const handleStartTimeChange = (time) => {
    if (time) {
      const endTimeValue = clampEndTimeToRemaining(
        time,
        dayjs(time).add(30, "minutes")
      );
      form.setFieldValue("endTime", endTimeValue);
      handleInputChange("startTime", time);
      handleInputChange("endTime", endTimeValue);
      form.validateFields(["endTime"]);
    }
  };

  useEffect(() => {
    const start = form.getFieldValue("startTime");
    const end = form.getFieldValue("endTime");
    if (!start || !end) return;
    const clamped = clampEndTimeToRemaining(start, end);
    if (!clamped.isSame(end, "minute")) {
      form.setFieldValue("endTime", clamped);
      handleInputChange("endTime", clamped);
    }
    form.validateFields(["endTime"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExceptionSelected, remainingDailyMinutes]);

  const renderVirtualMeetingForm = () => (
    <div className="virtual-meeting-form">
      <Form
        form={form}
        layout="vertical"
        onFinish={bookRoomAfterCheck}
        scrollToFirstError
      >
        <Flex gap="1.2rem" style={{ width: "100%" }} align="center">
          <div style={{ width: "48%" }}>
            <Form.Item
              label={<span className="required-label">Concurrency</span>}
              name="concurrenceTypeId"
              rules={[{ required: true, message: "Please select concurrency" }]}
            >
              <Select
                size="large"
                placeholder="Once"
                style={{ width: "100%" }}
                options={concurrenceOptions}
                onChange={(value) => {
                  form.validateFields(["concurrencyEndDate"]);
                }}
              />
            </Form.Item>
          </div>
          <div style={{ width: "48%" }}>
            <Form.Item label="Day of week" name="concurrence">
              <Select
                size="large"
                placeholder="Select day of week"
                style={{ width: "100%" }}
                options={_daysOfWeek}
                disabled={concurrencyType !== concurrenceOptions?.[1]?.value}
                onChange={(value) => {
                  form.validateFields([
                    "concurrencyStartDate",
                    "concurrencyEndDate",
                  ]);
                }}
              />
            </Form.Item>
          </div>
        </Flex>
        {/* Date Range */}
        <Flex gap="1.2rem" style={{ width: "100%" }} align="center">
          <Form.Item
            name="concurrencyStartDate"
            label={<span className="required-label">Start Date</span>}
            rules={[
              { required: true, message: "Select date is required" },
              { validator: validateBookingDateWithinWindow },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const concurrenceTypeId = getFieldValue("concurrenceTypeId");
                  const day = value?.day(); // 0 = Sunday, 6 = Saturday

                  if (concurrenceTypeId === 5 && (day === 0 || day === 6)) {
                    return Promise.reject(
                      "Start date must be a weekday (Mon–Fri)"
                    );
                  }

                  const concurrence = getFieldValue("concurrence"); // Expecting [3], etc.

                  if (concurrenceTypeId === 3 && day != concurrence) {
                    
                    return Promise.reject(
                      "Start date must match the selected week day"
                    );
                  }

                  if (concurrenceTypeId == 3 || concurrenceTypeId ==5)
                  {
                     if (endDate && value && value.isAfter(endDate, "day")) {
                       return Promise.reject("Start date must be before end date");
                     }
                  }

                 

                  return Promise.resolve();
                },
              }),
            ]}
            validateFirst={true}
          >
            <DatePicker
              format="DD-MM-YYYY"
              size="large"
              style={{ width: "100%" }}
              value={startDate}
              onChange={(date) => {
                handleInputChange("startDate", date);
                // Ensure form value is set
                form.setFieldValue("concurrencyStartDate", date);
                form.validateFields(["concurrencyEndDate"]);
              }}
              minDate={dayjs().startOf("day")}
              maxDate={maxBookableDate}
              allowClear={false}
              initialValues={startDate} // Add this to ensure initial value is recognized
            />
          </Form.Item>

          <Form.Item
            name="concurrencyEndDate"
            label={<span className="required-label">End Date</span>}
            rules={
              concurrencyType !== concurrenceOptions?.[0]?.value
                ? [
                    {
                      required: true,
                      message: "End Date is required",
                    },

                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startDate = getFieldValue("concurrencyStartDate");
                        const concurrenceTypeId =
                          getFieldValue("concurrenceTypeId");
                        const endDay = value?.day(); // 0 = Sunday, 6 = Saturday
                        const concurrence = getFieldValue("concurrence");

                        if (concurrenceTypeId === 5) {
                          if (!value) {
                            return Promise.reject(
                              new Error("End date is required")
                            );
                          }
                          if (value.isBefore(startDate, "day")) {
                            return Promise.reject(
                              new Error("End date cannot be before start date")
                            );
                          }
                          if (endDay === 0 || endDay === 6) {
                            return Promise.reject(
                              "End date must be a weekday (Mon–Fri)"
                            );
                          }
                        }

                        if (concurrenceTypeId === 3 && endDay != concurrence) {

                          if (value.isBefore(startDate, "day")) {
                            return Promise.reject(
                              new Error("End date cannot be before start date")
                            );
                          }
                          return Promise.reject(
                            "End date must match the selected week day"
                          );
                        }

                        if (value) {
                          const today = dayjs().startOf("day");
                          if (dayjs(value).isAfter(maxBookableDate, "day")) {
                            return Promise.reject(
                              new Error(
                                `Bookings can only be made up to ${maxAdvanceDays} days in advance. Please select a date on or before ${maxBookableDate.format(
                                  "DD-MM-YYYY"
                                )}.`
                              )
                            );
                          }
                          if (dayjs(value).isBefore(today, "day")) {
                            return Promise.reject(
                              new Error(
                                "End date cannot be in the past. Please select a valid date."
                              )
                            );
                          }
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]
                : []
            }
            // rules={[
            //   {
            //     required: concurrencyType !== concurrenceOptions?.[0]?.value,
            //     message: "Select date is required"
            //   }

            // ]}
            validateFirst={true}
          >
            <DatePicker
              format="DD-MM-YYYY"
              size="large"
              style={{ width: "100%" }}
              value={endDate}
              disabled={concurrencyType === concurrenceOptions?.[0]?.value}
              onChange={(date) => {
                handleInputChange("endDate", date);
                // Ensure form value is set
                form.setFieldValue("concurrencyEndDate", date);
              }}
              minDate={dayjs().startOf("day")}
              maxDate={maxBookableDate}
              allowClear={false}
              initialValues={endDate} // Add this to ensure initial value is recognized
            />
          </Form.Item>
        </Flex>
        {/* Time Range */}
        <Flex gap="1.2rem" style={{ width: "100%" }} align="center">
          <Form.Item
            name="startTime"
            label={<span className="required-label">Start Time</span>}
            rules={[{ required: true, message: "Start time is required" }]}
          >
            <TimePicker
              key={startDate}
              size="large"
              format="HH:mm"
              style={{ width: "100%" }}
              onChange={handleStartTimeChange}
              disabledTime={disabledTime}
              minuteStep={1}
              allowClear={false}
              needConfirm={false}
            />
          </Form.Item>

          <Form.Item
            label={<span className="required-label">End Time</span>}
            name="endTime"
            dependencies={["startTime"]}
            rules={[
              {
                required: true,
                message: "End time is required",
              },
              validateEndTimeWithinDailyLimit,
            ]}
          >
            <TimePicker
              key={startDate}
              size="large"
              format="HH:mm"
              style={{ width: "100%" }}
              onChange={(time) => handleInputChange("endTime", time)}
              minuteStep={1}
              allowClear={false}
              needConfirm={false}
            />
          </Form.Item>
        </Flex>

        {/* Supervisor / Reporting Manager (optional) */}
        <Form.Item
          label="Supervisor/Reporting Manager"
          name="managerEmpCode"
        >
          <Select
            size="large"
            allowClear
            placeholder="Select supervisor/reporting manager"
            style={{ width: "100%" }}
            options={employees
              .slice()
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((emp) => ({
                label: emp.label,
                value: emp.value,
                key: emp.value,
              }))}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            optionFilterProp="label"
          />
        </Form.Item>

        {/* Invitees - Required for virtual meetings */}
        <Form.Item
          label={
            <span className="required-label">Invitees (Internal Invitees)</span>
          }
          name="roomInvitees"
          rules={[
            // { required: true, message: "Please select at least one invitee" },
          ]}
        >
          <Select
            size="large"
            mode="multiple"
            placeholder="Select invitees"
            style={{ width: "100%" }}
            options={employees
              .slice()
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((emp) => ({
                label: emp.label,
                value: emp.value,
                key: emp.value,
              }))}
            onChange={handleInviteesChange}
            tagRender={tagRender}
            showSearch
            filterOption={(input, option) => {
              // Case-insensitive search on the label
              return (option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            optionFilterProp="label"
          />
        </Form.Item>

        {/* Other invites */}
        <Form.Item
          name="otherInvitees"
          label="Other Invitees (External Invitees)"
          rules={[
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                const emails = value.split(",").map((email) => email.trim());
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalidEmails = emails.filter(
                  (email) => !emailRegex.test(email)
                );
                if (invalidEmails.length > 0) {
                  return Promise.reject("Please enter valid email addresses");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            size="large"
            name="otherInvitees"
            id="otherInvitees"
            style={{ width: "100%" }}
            placeholder="example@email.com, example2@email.com"
          />
        </Form.Item>

        {/* Subject */}
        <Form.Item
          label={<span className="required-label">Subject</span>}
          name="subject"
          rules={[
            { required: true, message: "Subject is required" },
            {
              pattern: /^[a-zA-Z0-9\s_-]+$/, // Only allows letters, numbers and spaces
              message: "Special characters are not allowed in subject",
            },
            {
              max: 35,
              message: "Subject cannot be longer than 35 characters",
            },
          ]}
        >
          <Input
            type="text"
            name="subject"
            style={{ width: "100%" }}
            id="subject"
            size="large"
            placeholder="Enter meeting subject"
            maxLength={35}
          />
        </Form.Item>

        {/* Agenda */}
        <Form.Item name="agenda" label="Agenda">
          <ReactQuill
            value={agenda}
            onChange={setAgenda}
            theme="snow"
            modules={{
              toolbar: [
                [{ font: [] }],
                [{ size: [] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
              ],
            }}
            style={{
              height: "150px",
              marginBottom: "50px",
            }}
          />
        </Form.Item>

        <div className="button-container">
          <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            disabled={isBooking}
          >
            Book New Meeting
          </Button>
        </div>
      </Form>
    </div>
  );

  useEffect(() => {
    const today = dayjs().startOf("day");

    form.setFieldsValue({
      concurrenceTypeId: 1,
      concurrencyStartDate: today,
      concurrencyEndDate: today,
    });

    setStartDate(today);
  }, [meetingType]); // Run once when component mounts

  const handleSave = () => {
    // Save logic (e.g., POST to API or localStorage)
    setIsModalOpen(false); // Optional: close modal after saving
  };

  const handleStartNow = () => {
    // Logic to launch the meeting room
    setIsModalOpen(false); // Close modal
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    message.success("Copied to clipboard!");
  };

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div className="form-container">
        <div className="meeting-type-buttons">
          {/* <Button
            type={meetingType === "virtual" ? "primary" : "default"}
            onClick={() => handleMeetingTypeChange("virtual")}
            className={`meeting-type-btn ${
              meetingType === "virtual" ? "active" : ""
            }`}
          >
            Online Meeting
          </Button> */}

          {/* <Button
            type={meetingType === "onsite" ? "primary" : "default"}
            onClick={() => handleMeetingTypeChange("onsite")}
            className={`meeting-type-btn ${
              meetingType === "onsite" ? "active" : ""
            }`}
          >
            Onsite Meeting
          </Button> */}
        </div>

        <Modal
          title={<div>Your meeting’s ready
            <hr style={{ border: 'none', borderTop: '1px solid #D9D9D9'  }} /> 
             </div>}
          open={isModalOpen}
          onCancel={handleCancel}
          footer={[

             <hr style={{ border: 'none', borderTop: '1px solid #D9D9D9' }} /> ,
            <Button key="save"  type="primary" onClick={()=>{createInstantMeeting(false)}}>
              Save
            </Button>,
            <Button key="start" type="primary" onClick={()=>{createInstantMeeting(true)}}>
              Start Now
            </Button>,
          ]}
          centered
          maskClosable={false} // prevents closing by clicking outside
          keyboard={false}
          width="430px"
          height="603"
        >
          {/* 👇 Add image from public folder */}
          <img
            src="/images/instant_meeting_popup.svg"
            alt="Meeting illustration"
            style={{ width: "100%", marginBottom: 20 }}
          />

          <Text type="secondary" style={{ display: 'block', textAlign: 'center' }}>
            Anyone with the link can access the meeting.
          </Text>


          <div style={{ marginTop: 20 , marginBottom :40 }}>
            <Text strong>Organizer Link</Text>
            <Input
              value={moderatorLink}
              addonAfter={
                <CopyOutlined
                  style={{ cursor: "pointer", color: '#1890ff' }}
                  onClick={() => copyToClipboard(moderatorLink)}
                />
              }
              style={{ marginTop: 5, marginBottom: 15 }}
            />

            <Text strong>Invitee Link</Text>
            <Input
              value={meetingLink}
              addonAfter={
                <CopyOutlined
                  style={{ cursor: "pointer", color: '#1890ff' }}
                  onClick={() => copyToClipboard(meetingLink)}
                />
              }
              style={{ marginTop: 5 }}
            />
          </div>
        </Modal>

        {/* {meetingType === "virtual" ? (
          !isScheduleMeeting ? (
            <div
              className="virtual-meeting-form"
              style={{ textAlign: "center", padding: "30px" }}
            >
              <img
                src="/images/online_meeting.svg"
                alt="Virtual Meeting"
                style={{ width: "60%", maxWidth: 316, marginBottom: 33 }}
              />
              <Paragraph>
                Choose <strong>'Instant meeting'</strong> to generate a quick
                invite link, or click <strong>'Create meeting for later'</strong> to schedule a
                new virtual meeting.
              </Paragraph>

              <Space
                direction="vertical"
                size="middle"
                style={{ marginTop: 30, marginBottom: 35 }}
              >
                <Button
                  type="link"
                  icon={<LinkOutlined />}
                  size="large"
                  style={{ fontSize: 16 }}
                  onClick={() => handleOpenModal()}
                >
                  Start an instant meeting
                </Button>

                <Divider plain>Or</Divider>

                <Button
                  type="link"
                  icon={<TeamOutlined />}
                  size="large"
                  style={{ fontSize: 16 }}
                  onClick={() => setScheduleMeeting(true)}
                >
                  Create a meeting for later
                </Button>
              </Space>
            </div>
          ) : (
            renderVirtualMeetingForm()
          )
        ) : (
        )} */}
          <div className="virtual-meeting-form">
            <Form
              form={form}
              onFinish={bookRoomAfterCheck}
              layout="vertical"
              scrollToFirstError
            >
              {/* First row - Place, Meeting rooms, Subject */}
              <div className="form-row">
                <Form.Item
                  label={<span className="required-label">Place</span>}
                  name="placeId"
                  rules={[{ required: true, message: "Please select a place" }]}
                >
                  <Select
                    size="large"
                    id="placeId"
                    placeholder="Select a place"
                    options={cityList}
                    onChange={(value) => {
                      form.setFieldValue("placeId", value);
                    }}
                     //defaultValue={cityList[0]?.value}
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  label={<span className="required-label">Meeting rooms</span>}
                  name="mrId"
                  rules={[
                    { required: true, message: "Please select a meeting room" },
                  ]}
                >
                  <Select
                    size="large"
                    id="mrId"
                    options={filteredMeetingRooms}
                    placeholder="Select meeting room"
                    style={{ width: "100%" }}
                    onChange={(value) => {
                      setSelectedMeetingRoom(value);
                    }}
                  />
                </Form.Item>
              </div>

              <div className={isWeekdayRecurrence ? "form-row" : undefined}>
              {/* Admin only: recurrence + end date */}
              {isAdmin && (
                <div className="form-row" style={weekdayRowStyle}>
                  <Form.Item
                    style={weekdayOrder(1)}
                    label={<span className="required-label">Booking type</span>}
                    name="concurrenceTypeId"
                    rules={[
                      { required: true, message: "Booking type is required" },
                    ]}
                  >
                    <Select
                      size="large"
                      options={concurrenceOptions}
                      optionRender={(option) =>
                        option.data.fullLabel || option.data.label
                      }
                      onChange={(value) => {
                        if (Number(value) !== 5) {
                          const today = dayjs().startOf("day");
                          form.setFieldsValue({
                            concurrencyStartDate: today,
                            concurrencyEndDate: today,
                          });
                          setStartDate(today);
                          const start = form.getFieldValue("startTime");
                          if (
                            start &&
                            dayjs()
                              .hour(start.hour())
                              .minute(start.minute())
                              .isBefore(dayjs())
                          ) {
                            form.setFieldsValue({
                              startTime: null,
                              endTime: null,
                            });
                          }
                        } else {
                          form.setFieldValue("isException", false);
                          form.setFieldValue(
                            "concurrencyEndDate",
                            form.getFieldValue("concurrencyStartDate")
                          );
                        }
                      }}
                    />
                  </Form.Item>

                  {isWeekdayRecurrence && (
                  <Form.Item
                    style={weekdayOrder(6)}
                    label={
                      isWeekdayRecurrence ? (
                        <span className="required-label">End Date</span>
                      ) : (
                        "End Date"
                      )
                    }
                    name="concurrencyEndDate"
                    dependencies={["concurrencyStartDate", "concurrenceTypeId"]}
                    rules={
                      isWeekdayRecurrence
                        ? [
                            { required: true, message: "End date is required" },
                            { validator: validateBookingDateWithinWindow },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const start = getFieldValue(
                                  "concurrencyStartDate"
                                );
                                if (
                                  value &&
                                  start &&
                                  dayjs(value).isBefore(start, "day")
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      "End date cannot be before start date"
                                    )
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]
                        : []
                    }
                  >
                    <DatePicker
                      format="DD-MM-YYYY"
                      size="large"
                      style={{ width: "100%" }}
                      minDate={bookingDateValue.startOf("day")}
                      maxDate={maxBookableDate}
                      allowClear={false}
                    />
                  </Form.Item>
                  )}
                </div>
              )}

              {/* Date (today only; Every Weekday admins pick a start date) + times */}
              <div className="form-row" style={weekdayRowStyle}>
                {isWeekdayRecurrence ? (
                  <Form.Item
                    style={weekdayOrder(5)}
                    label={<span className="required-label">Start Date</span>}
                    name="concurrencyStartDate"
                    rules={[
                      { required: true, message: "Start date is required" },
                      { validator: validateBookingDateWithinWindow },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const day = value ? dayjs(value).day() : null;
                          if (
                            Number(getFieldValue("concurrenceTypeId")) === 5 &&
                            (day === 0 || day === 6)
                          ) {
                            return Promise.reject(
                              new Error("Start date must be a weekday (Mon–Fri)")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      format="DD-MM-YYYY"
                      size="large"
                      style={{ width: "100%" }}
                      minDate={dayjs().startOf("day")}
                      maxDate={maxBookableDate}
                      allowClear={false}
                      onChange={(date) => {
                        handleInputChange("startDate", date);
                        const end = form.getFieldValue("concurrencyEndDate");
                        if (
                          !isWeekdayRecurrence ||
                          !end ||
                          dayjs(end).isBefore(date, "day")
                        ) {
                          form.setFieldValue("concurrencyEndDate", date);
                        }
                        const start = form.getFieldValue("startTime");
                        if (
                          start &&
                          dayjs(date).isSame(dayjs(), "day") &&
                          dayjs()
                            .hour(start.hour())
                            .minute(start.minute())
                            .isBefore(dayjs())
                        ) {
                          form.setFieldsValue({ startTime: null, endTime: null });
                        }
                      }}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item label={<span className="required-label">Date</span>}>
                    <Input
                      size="large"
                      value={`Today - ${dayjs().format("DD-MM-YYYY")}`}
                      readOnly
                      style={{
                        cursor: "default",
                        backgroundColor: "#ffffff",
                        color: "rgba(0, 0, 0, 0.88)",
                      }}
                    />
                  </Form.Item>
                )}

                <Form.Item
                  style={weekdayOrder(2)}
                  label={<span className="required-label">Start Time</span>}
                  name="startTime"
                  rules={[
                    { required: true, message: "Start time is required" },
                  ]}
                >
                  <ClockTimePicker
                    size="large"
                    style={{ width: "100%" }}
                    onChange={handleStartTimeChange}
                    disabledTime={disabledTime}
                    placeholder="Select start time"
                    key={startDate}
                  />
                </Form.Item>
              </div>

              <div className="form-row" style={weekdayRowStyle}>
                <Form.Item
                  style={weekdayOrder(3)}
                  label={<span className="required-label">End Time</span>}
                  name="endTime"
                  dependencies={["startTime", "isException"]}
                  rules={[
                    {
                      required: true,
                      message: "End time is required",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startTime = getFieldValue("startTime");
                        if (!value || !startTime) {
                          return Promise.resolve();
                        }
                        if (value.isBefore(startTime.add(15, "minutes"))) {
                          return Promise.reject(
                            "End time must be at least 15 minutes after start time"
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                    validateEndTimeWithinDailyLimit,
                  ]}
                >
                  <ClockTimePicker
                    key={`${startDate}-${remainingDailyMinutes}-${isExceptionSelected}`}
                    size="large"
                    disabledTime={disabledEndTime}
                    durationFrom={watchedStartTime}
                    placeholder="Select end time"
                    style={{ width: "100%" }}
                    onChange={(time) => {
                      const start = form.getFieldValue("startTime");
                      const clamped = clampEndTimeToRemaining(start, time);
                      form.setFieldValue("endTime", clamped);
                      handleInputChange("endTime", clamped);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  style={weekdayOrder(4)}
                  label={
                    <span style={{ visibility: "hidden" }} aria-hidden>
                      Usage
                    </span>
                  }
                >
                  <div
                    style={{
                      minHeight: 40,
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 12px",
                      background: usageBadgeColors.background,
                      border: `1px solid ${usageBadgeColors.border}`,
                      borderRadius: 6,
                      fontSize: 13,
                      color: "#434343",
                      lineHeight: 1.45,
                    }}
                  >
                    <span>
                      {isBookingToday
                        ? "Today's usage"
                        : `Usage on ${bookingDateValue.format("DD-MM-YYYY")}`}
                      :{" "}
                      <strong>
                        {formatDurationLabel(dailyUsedMinutes)}
                      </strong>{" "}
                      /{" "}
                      <strong>
                        {formatDurationLabel(dailyLimitMinutes)}
                      </strong>
                      {isExceptionSelected ? " " : ""}
                      <span style={{ color: "#8c8c8c" }}>
                        {" "}
                        · {formatDurationLabel(remainingDailyMinutes)} left
                      </span>
                    </span>
                  </div>
                </Form.Item>
              </div>
              </div>

              {/* Exception + Supervisor */}
              <Form.Item
                name="isException"
                valuePropName="checked"
                style={{ marginBottom: 8 }}
              >
                <Checkbox
                  className="exception-checkbox"
                  disabled={exceptionsExhausted || isWeekdayRecurrence}
                  onChange={(e) => {
                    if (e.target.checked && exceptionsExhausted) {
                      form.setFieldValue("isException", false);
                      toast.error(
                        `You have used all ${MONTHLY_EXCEPTION_LIMIT} exceptions for this month. Shorten the booking to within ${MAX_DAILY_BOOKING_HOURS} hours/day, or try again next month.`
                      );
                      return;
                    }
                    form.validateFields(["endTime", "managerEmpCode"]);
                  }}
                >
                  Use monthly exception (over {MAX_DAILY_BOOKING_HOURS} hours, up to{" "}
                  {MAX_EXCEPTION_DAILY_BOOKING_HOURS} hours day total)
                </Checkbox>
              </Form.Item>
              {isWeekdayRecurrence ? (
                <div
                  style={{
                    marginBottom: 12,
                    fontSize: 13,
                    color: "#8c8c8c",
                  }}
                >
                  Exceptions cannot be used with Every Weekday bookings. Keep
                  each day within {MAX_DAILY_BOOKING_HOURS} hours.
                </div>
              ) : exceptionsExhausted ? (
                <div
                  style={{
                    marginBottom: 12,
                    padding: "8px 12px",
                    background: "#fff2f0",
                    border: "1px solid #ffccc7",
                    borderRadius: 6,
                    fontSize: 13,
                    color: "#cf1322",
                    lineHeight: 1.45,
                  }}
                >
                  No exceptions left this month ({exceptionQuota.limit}/
                  {exceptionQuota.limit} used). You cannot enable a monthly
                  exception until next month.
                </div>
              ) : isExceptionSelected ? (
                <div
                  style={{
                    marginBottom: 12,
                    fontSize: 13,
                    color: "#595959",
                  }}
                >
                  Exceptions left this month:{" "}
                  <strong>
                    {exceptionQuota.remaining}/{exceptionQuota.limit}
                  </strong>{" "}
                  (used {exceptionQuota.limit - exceptionQuota.remaining}
                  {exceptionQuota.used > 0
                    ? `; ${exceptionQuota.used} already started`
                    : ""}
                  ).
                </div>
              ) : (
                <div
                  style={{
                    marginBottom: 12,
                    fontSize: 13,
                    color: "#8c8c8c",
                  }}
                >
                  Exceptions left this month:{" "}
                  <strong>
                    {exceptionQuota.remaining}/{exceptionQuota.limit}
                  </strong>
                  {exceptionQuota.limit - exceptionQuota.remaining > 0
                    ? ` (used ${
                        exceptionQuota.limit - exceptionQuota.remaining
                      })`
                    : ""}
                </div>
              )}

              <Form.Item
                label={
                  isExceptionSelected ? (
                    <span className="required-label">
                      Supervisor/Reporting Manager
                    </span>
                  ) : (
                    "Supervisor/Reporting Manager"
                  )
                }
                name="managerEmpCode"
                extra="For record and escalation. The supervisor is likely to be notified."
                rules={
                  isExceptionSelected
                    ? [
                        {
                          required: true,
                          message:
                            "Supervisor/Reporting Manager is required when using a monthly exception.",
                        },
                      ]
                    : []
                }
              >
                <Select
                  size="large"
                  allowClear
                  placeholder="Select supervisor/reporting manager"
                  style={{ width: "100%" }}
                  options={employees
                    .slice()
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((emp) => ({
                      label: emp.label,
                      value: emp.value,
                      key: emp.value,
                    }))}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                />
              </Form.Item>

              {/* Invitees - Not required for onsite meetings */}
              <Form.Item label="Invitees" name="roomInvitees">
                <Select
                  size="large"
                  mode="multiple"
                  placeholder="Select invitees"
                  style={{ width: "100%" }}
                  options={employees
                    .slice()
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((emp) => ({
                      label: emp.label,
                      value: emp.value,
                      key: emp.value,
                    }))}
                  onChange={handleInviteesChange}
                  tagRender={tagRender}
                  showSearch
                  filterOption={(input, option) => {
                    // Case-insensitive search on the label
                    return (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  optionFilterProp="label"
                />
              </Form.Item>

              {/* Link */}
              <Form.Item
                label="Link"
                name="meetingRoomLink"
                rules={[
                  {
                    type: "url",
                    message:
                      "Please enter a valid URL for the meeting room link",
                  },
                  {
                    validator: (_, value) =>
                      !value || value.startsWith("https://")
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("URL must start with https://")
                          ),
                  },
                ]}
              >
                <Input size="large" placeholder="Enter meeting room link" />
              </Form.Item>

              {/* Subject */}
              <Form.Item
                label={<span className="required-label">Subject</span>}
                name="subject"
                rules={[{ required: true, message: "Subject is required" }]}
              >
                <Input size="large" placeholder="Enter meeting subject" />
              </Form.Item>

              <div
                style={{
                  marginBottom: "1rem",
                  padding: "12px 14px",
                  background: "#fafafa",
                  border: "1px solid #f0f0f0",
                  borderRadius: 6,
                  fontSize: 13,
                  color: "#595959",
                  lineHeight: 1.55,
                }}
              >
                <strong>Note — booking restrictions:</strong>
                <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
                  <li>
                    Rooms can only be booked for today.
                  </li>
                  <li>
                    Total booking time per person is limited to{" "}
                    {MAX_DAILY_BOOKING_HOURS} hours per day (across all rooms).
                  </li>
                  <li>
                    You may book more than one room on the same day as long as
                    the combined duration stays within {MAX_DAILY_BOOKING_HOURS}{" "}
                    hours (or up to {MAX_EXCEPTION_DAILY_BOOKING_HOURS} hours with
                    an exception).
                  </li>
                  <li>
                    Total {MONTHLY_EXCEPTION_LIMIT} extensions/exceptions per
                    month (each lets you extend that day&apos;s total up to{" "}
                    {MAX_EXCEPTION_DAILY_BOOKING_HOURS} hours).
                  </li>
                </ul>
              </div>

              {/* Agenda */}
              <Form.Item label="Agenda" name="agenda">
                <ReactQuill
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ font: ["Sans Serif"] }],
                      [{ size: ["Normal"] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                    ],
                  }}
                  style={{
                    height: "150px",
                    marginBottom: "80px",
                  }}
                />
              </Form.Item>

              <div className="button-container">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="submit-button"
                  disabled={isBooking}
                >
                  Book Meeting Room
                </Button>
              </div>
            </Form>
          </div>

        {isBooking && (
          <div className="loading-spinner">
            <Spin size="large" />
            <span style={{ paddingLeft: "10px" }}>Create Meeting...</span>
          </div>
        )}
      </div>

      <div className="calendar-container">
        <WeeklyCalendar
          selectedMeetingRoom={selectedMeetingRoom}
          selectedPlace={selectedCity}
          events={roomEvents}
          selectSlot={handleSelectSlot}
          startDate={startDate}
          endDate={endDate}
          startTime={startTime}
          endTime={endTime}
          selectedSlot={selectedSlot}
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
      </div>
    </div>
  );
};

export default Rb;
